export default __webpack_public_path__ + "static/media/band8.049b1a37.jfif";